export default __webpack_public_path__ + "static/media/landing-backdrop.7ff334f1.png";